import { Search, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { haptics } from '../lib/telegram';

/**
 * Поиск с задержкой: запрос уходит, когда человек перестал печатать.
 * Иначе на каждый символ летит обращение к магазину.
 */
export function SearchBar({
  value,
  onChange,
  placeholder,
  delayMs = 350,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  delayMs?: number;
}) {
  const [draft, setDraft] = useState(value);
  const [lastValue, setLastValue] = useState(value);

  // Значение могли сбросить снаружи (например, сменой вкладки). Подстраиваем
  // состояние прямо в рендере — так React советует реагировать на смену пропа,
  // и это дешевле, чем лишний проход через эффект.
  if (value !== lastValue) {
    setLastValue(value);
    setDraft(value);
  }

  useEffect(() => {
    if (draft === value) return;
    const timer = window.setTimeout(() => onChange(draft), delayMs);
    return () => window.clearTimeout(timer);
  }, [draft, value, onChange, delayMs]);

  return (
    <div className="relative px-4 pb-2.5">
      <Search
        size={17}
        className="text-muted pointer-events-none absolute top-1/2 left-7 -translate-y-1/2"
      />
      <input
        type="search"
        inputMode="search"
        enterKeyHint="search"
        value={draft}
        onChange={(event) => setDraft(event.target.value)}
        placeholder={placeholder}
        className="bg-surface-2 h-10 w-full rounded-xl pr-9 pl-9 text-[15px] outline-none placeholder:text-[var(--text-muted)] focus:ring-2 focus:ring-[var(--accent)]/35"
      />
      {draft.length > 0 && (
        <button
          type="button"
          aria-label="Очистити"
          onClick={() => {
            haptics.tap();
            setDraft('');
            onChange('');
          }}
          className="text-muted absolute top-1/2 right-7 -translate-y-1/2 p-1"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}
